<template>
  <div class="main-container">
    <home-nav-bar v-if="editEnable" title="查看溯源">
      <template #left>
        <van-icon name="arrow-left" @click="$router.back()" />
      </template>
    </home-nav-bar>
    <init-two v-if="radarShow" class="init-two" :show.sync="radarShow" :radar-bg-image="traceCode.productPic" :tab-list="tabList" />
    <div class="primary">
      <pick-info class="content-item" :trace-data="traceData" />
      <test-report-list v-if="traceData.inspectCertInfoJSON && traceData.inspectCertInfoJSON.length" class="content-item module" :test-report-list="traceData.inspectCertInfoJSON" />
      <farm-land-data :user-id="userId" class="content-item module" :trace-data="traceData" />
      <farm-work-record-steps class="content-item module" :farm-work-records="traceData.farmWorkJSON" />
      <company-data class="content-item module" :company-data="traceData.company" />
      <delivery-data class="content-item module" :logistic-code="traceData.logisticCode" :logistic-company="traceData.logisticCompany" />
      <div class="bottom-fix-box">
        <div class="content wh-flex-between">
          <div class="left-content">
            <div class="percent">
              100%
            </div>
            <div class="annotation">
              资源完整度
            </div>
          </div>
          <div class="right-content">
            <van-button v-if="editEnable" class="btn" round native-type="button" type="info" @click="editTraceSource">
              编辑溯源
            </van-button>
            <van-button class="btn" round native-type="button" type="primary" @click="viewTraceSourceQr">
              查看溯源码
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <qr-trace-dialog v-model="traceCodeQrDialogShow" :trance-code="traceCode" />
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import InitTwo from '@/views/productManage/TraceSource/components/InitTwo'
import QrTraceDialog from '@/views/productManage/TraceSource/components/QrTraceDialog'
import FarmLandData from '@/views/productManage/TraceSource/components/FarmLandData'
import PickInfo from '@/views/productManage/TraceSource/components/PickInfo'
import TestReportList from '@/views/productManage/TraceSource/components/TestReportList'
import CompanyData from '@/views/productManage/TraceSource/components/CompanyData'
import { traceDataByTraceCode } from '@/utils/mixins/traceDataByTraceCode'
import FarmWorkRecordSteps from '@/views/productManage/TraceSource/components/FarmWorkRecordSteps'
import DeliveryData from '@/views/productManage/TraceSource/components/DeliveryData'

export default {
  name: 'TraceSource',
  components: { DeliveryData, FarmWorkRecordSteps, CompanyData, TestReportList, PickInfo, FarmLandData, QrTraceDialog, InitTwo, HomeNavBar },
  mixins: [traceDataByTraceCode],
  data() {
    return {
      tabList: [
        {
          name: '权威检测',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '产地信息',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '种植环节',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '生产企业',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        }
      ],
      radarShow: true,
      traceCodeQrDialogShow: false
    }
  },
  computed: {
    userId() {
      return this.traceData.userId
    },
    editEnable() {
      return this.$store.getters.isLogin && this.$route.name === 'TraceSource'
    }
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      // 开发模式暂不显示过场动画
      setTimeout(() => {
        this.radarShow = false
      }, 300)
    } else {
      setTimeout(() => {
        this.radarShow = false
      }, 6000) // 最多展示 6s 隐藏雷达追溯动画
    }
  },
  methods: {
    editTraceSource() {
      this.$router.push({
        name: 'TraceSourceEditor',
        query: {
          landId: this.landId,
          formType: 'edit',
          traceCode: this.traceCode
        }
      })
    },
    viewTraceSourceQr() {
      this.traceCodeQrDialogShow = true
    }
  }
}
</script>

<style lang='less' scoped>
.main-container {
  background: #f6f5f5;
}
.init-two {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  background: #ffffff;
}
.primary {
  .content-item {
    margin-top: 8px;
    background: #ffffff;
    &.module {
      padding: 16px;
    }
  }
}
.bottom-fix-box {
  @height: 64px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .content {
    z-index: 2;
    height: @height;
    position: fixed;
    z-index: 99;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 10px;
    box-shadow: 0 0 10px 0 #ccc;
    background: #fff;
    .left-content {
      .percent {
        color: #e85f1a;
      }
      .annotation {
        font-size: 12px;
        color: #cccccc;
      }
    }
    .right-content {
      .btn + .btn {
        margin-left: 10px;
      }
    }
  }
}
</style>
